import { DrfRequestStatus, type MapFulfillmentRequest, RequestFlag } from './types';

export const drfStatusLabels: { [key in DrfRequestStatus]: string } = {
  [DrfRequestStatus.PaymentPending]: 'Payment Pending',
  [DrfRequestStatus.Pending]: 'New',
  [DrfRequestStatus.NeedsReview]: 'Needs Review',
  [DrfRequestStatus.Fulfilled]: 'Fulfilled',
  [DrfRequestStatus.AutoFulfilled]: 'Auto-Fulfilled',
  [DrfRequestStatus.Rejected]: 'Rejected',
  [DrfRequestStatus.Cancelled]: 'Cancelled',
};

export const requestFlagLabels: { [key in RequestFlag]: string } = {
  [RequestFlag.BlockedDomain]: 'Blocked email domain',
  [RequestFlag.ExceedsLengthLimit]: 'Project exceeds length limit of 0.5 miles',
  [RequestFlag.ExceedsAreaLimit]: 'Project exceeds area limit of 20 acres',
  [RequestFlag.CnpCriticalInfrastructure]: 'Project is within CNP critical infrastructure boundary',
};

export type PaymentMethod = NonNullable<MapFulfillmentRequest['paymentMethod']>['type'];

export const paymentMethodLabels: { [method in PaymentMethod]: string } = {
  card: 'Credit Card',
  waived: 'Waived Fees',
  other: 'Other',
};
